<div class="component-viewer">
    <mat-card>
        <mat-card-header style="display: inline;">
            <div class="row w-100">
                <div class="col-6 text-start">
                    <h2 class="mb-0">Sponsors</h2>
                </div>
                <div class="col-6 text-end">
                    <button *ngIf="selectedIteration" mat-raised-button class="pull-right"
                    [routerLink]="['/outing-management/administration/sponsor', 'create', searchKey]">Add <mat-icon>add</mat-icon></button>
                </div>
            </div>
        </mat-card-header>
        <gt-table *ngIf="true" [loading]="isLoading" [defaultPageSize]="10" [updateFilterEvent]="updateFilterEvent"
            [filter]="filter" [data]="sponsors" (filterChanged)="getSponsors()" (filterReset)="resetFilter()">
        </gt-table>
        <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        <table mat-table [dataSource]="sponsors" matSort (matSortChange)="sortData($event)">
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="name">Name</th>
                <td mat-cell *matCellDef="let sponsor">
                    <a [routerLink]="['../sponsor/details/', sponsor.id]">{{sponsor.name}}</a>
                </td>
            </ng-container>
            <ng-container matColumnDef="company">
                <th mat-header-cell *matHeaderCellDef>Company</th>
                <td mat-cell *matCellDef="let sponsor">{{sponsor.company}}</td>
            </ng-container>
            <ng-container matColumnDef="requestReceipe">
                <th mat-header-cell *matHeaderCellDef>Request Receipe</th>
                <td mat-cell *matCellDef="let sponsor"><yes-no [value]="sponsor.type"></yes-no></td>
            </ng-container>
            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef>Short Name</th>
                <td mat-cell *matCellDef="let sponsor">
                    <ng-container *ngIf="sponsor.type == 1">Hole Sponsor</ng-container>
                    <ng-container *ngIf="sponsor.type == 2">Cart Sponsor</ng-container>
                    <ng-container *ngIf="sponsor.type == 3">Donation</ng-container>
                    <ng-container *ngIf="sponsor.type == 4">Team</ng-container>
                    <ng-container *ngIf="sponsor.type == 5">Other</ng-container>
                </td>
            </ng-container>
            <ng-container matColumnDef="amount">
                <th mat-header-cell *matHeaderCellDef>Amount</th>
                <td mat-cell *matCellDef="let sponsor">${{sponsor.amount}}</td>
            </ng-container>
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let sponsor">
                    <a mat-stroked-button *ngIf="canEditOrDelete()"
                        [routerLink]="['../sponsor/edit/', sponsor.id]">
                        Edit <mat-icon>edit</mat-icon>
                    </a>&nbsp;
                    <button mat-stroked-button color="warn" *ngIf="canEditOrDelete()" (click)="delete(sponsor)">
                        Delete <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </mat-card>
</div>